// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@guestsupply/App/SharedStyles/CartLineSharedStyles";
import xOrderInformationStyles from "@guestsupply/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderLinesListStyles } from "@guestsupply/Overrides/Components/OrderLinesList";
import { color, getSystemColor, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
    container: {
        css: css`
            margin-bottom: 0;
        `,
    },
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    height: "91",
    width: "91",
    css: css`
        height: 91px;
        width: 91px;
        img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
        }
    `,
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
orderLinesListStyles.surchargesStyles = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    valueText: {
        css: css`
            margin-bottom: 12px;
            @media print {
                float: left;
                width: 100%;
            }
        `,
    },
    qtyLabel: {
        css: css`
            display: block;
            @media print {
                float: left;
                width: 100%;
            }
        `,
    },
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            @media print {
                content: "";
                display: table;
                clear: both;
            }
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            @media print {
                content: "";
                display: table;
                clear: both;
            }
        `,
    },
};

orderLinesListStyles.qtyShippedField = {
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
};

orderLinesListStyles.productInfoSectionOptionsGridItem = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.promotionsContainer = {
    ...cartLineSharedStyles.promotionsContainer,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.lineHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 0.5fr 1.5fr 1fr 1fr 1fr 1fr;
        `,
    },
    total: {
        css: css`
            grid-column: 6/ 7;
        `,
    },
    surcharges: {
        css: css`
            grid-column: 5/ 6;
            padding: 8px 0;
            border-right: 1px solid ${color("common.border")};
        `,
    },
};

orderLinesListStyles.cartLineContainer = {
    container: {
        css: css`
            grid-template-columns: 0.5fr 1.5fr 1fr 1fr 1fr 1fr;
        `,
    },
    total: {
        css: css`
            grid-column: 6 / 7;
            ${xScreen("lte", "md")} {
                grid-row: 4 / 5;
                grid-column: 5 / 7;
            }
            @media print {
                min-width: 15%;
            }
        `,
    },
    surcharges: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-row: 4 / 5;
                grid-column: 3 / 5;
            }
            @media print {
                min-width: 15%;
                min-height: 50px;
                float: left;
            }
        `,
    },
};

orderLinesListStyles.groupTitle = {
    ...xOrderInformationStyles.groupLines?.groupTitle,
};
orderLinesListStyles.groupWrapper = {
    ...xOrderInformationStyles.groupLines?.groupWrapper,
};

orderLinesListStyles.regularPrice = {
    size: 14,
    weight: 400,
    lineHeight: "16px",
    css: css`
        text-decoration: line-through;
    `,
};

orderLinesListStyles.trackingNumberContainer = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

orderLinesListStyles.trackingNumber = {
    text: {
        size: 12,
        lineHeight: "15px",
        weight: 500,
        css: css`
            margin-right: 4px;
        `,
    },
    link: {
        typographyProps: {
            size: 12,
            lineHeight: "15px",
            css: css`
                display: flex;
            `,
        },
    },
};

orderLinesListStyles.trackingNumberStatus = {
    extendedStyles: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 4px;
                width: auto;
                ${xScreen("lte", "xs")} {
                    flex-direction: column;
                    align-items: flex-start;
                }
            `,
        },
        heading: {
            size: 12,
            lineHeight: "15px",
            weight: 500,
            css: css`
                color: ${getSystemColor("text.main")};
                text-transform: capitalize;
                white-space: nowrap;
            `,
        },
        text: {
            css: css`
                font-size: 12px;
                line-height: 15px;
                white-space: nowrap;
                display: flex;
            `,
        },
    },
};

orderLinesListStyles.trackingNumberStyle = {
    extendedStyles: {
        wrapper: {
            css: css`
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 4px;
                width: auto;
            `,
        },
        heading: {
            size: 12,
            lineHeight: "15px",
            weight: 500,
            css: css`
                color: ${getSystemColor("text.main")};
                text-transform: capitalize;
                white-space: nowrap;
            `,
        },
        text: {
            css: css`
                font-size: 12px;
                line-height: 15px;
                white-space: nowrap;
            `,
        },
    },
};

orderLinesListStyles.tooltipStyle = {
    cssOverrides: {
        tooltipWrapper: css`
            height: 18px;
            display: flex;
        `,
        tooltipContainer: css`
            max-width: fit-content;
        `,
    },
};
